import { render, staticRenderFns } from "./SplitOwnerTable.vue?vue&type=template&id=12f329fa&scoped=true&"
import script from "./SplitOwnerTable.vue?vue&type=script&lang=js&"
export * from "./SplitOwnerTable.vue?vue&type=script&lang=js&"
import style0 from "./SplitOwnerTable.vue?vue&type=style&index=0&id=12f329fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f329fa",
  null
  
)

export default component.exports